import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Palette, Menu, X } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { navLinks } from '../mock';

const Navbar = () => {
  const { theme, cycleTheme } = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <header
      className="w-full sticky top-0 z-50 transition-colors duration-500"
      style={{ background: theme.nav, borderBottom: `1px solid ${theme.cardBorder}` }}
    >
      <div className="w-full max-w-[1800px] mx-auto pl-4 pr-6 lg:pl-6 lg:pr-10 h-20 flex items-center justify-between gap-6 lg:gap-16">
        <Link to="/" className="flex items-center gap-3 group shrink-0">
          <img
            src={theme.logo}
            alt="SVF crest"
            className="w-16 h-16 lg:w-[68px] lg:h-[68px] object-contain transition-transform duration-500 group-hover:rotate-6"
            style={{ filter: 'drop-shadow(0 3px 10px rgba(0,0,0,0.45))' }}
          />
          <span
            className="hidden sm:block font-serif text-sm lg:text-[15px] font-semibold whitespace-nowrap"
            style={{ color: theme.navText, letterSpacing: '0.28em' }}
          >
            SAGI VENKATA NARASIMHAM FOUNDATION (SVF)
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8 ml-auto">
          {navLinks.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === '/'}
              className="font-serif text-[15px] tracking-wide transition-colors duration-300 relative"
              style={({ isActive }) => ({ color: isActive ? theme.navHover : theme.navText })}
            >
              {({ isActive }) => (
                <span className="relative">
                  {n.label}
                  <span
                    className="absolute -bottom-1 left-0 h-[1px] transition-all duration-300"
                    style={{ background: theme.navHover, width: isActive ? '100%' : '0%' }}
                  />
                </span>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={cycleTheme}
            className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-full border text-sm font-medium transition-all duration-300 hover:scale-[1.03]"
            style={{
              borderColor: theme.brand,
              color: theme.navText,
              background: 'transparent',
            }}
          >
            <Palette size={16} />
            <span>{theme.nextLabel}</span>
          </button>
          <button
            className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-md"
            style={{ color: theme.navText }}
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          className="lg:hidden px-6 pb-6"
          style={{ background: theme.nav, borderTop: `1px solid ${theme.cardBorder}` }}
        >
          <div className="flex flex-col gap-4 pt-4">
            {navLinks.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === '/'}
                onClick={() => setOpen(false)}
                className="font-serif text-base tracking-wide"
                style={({ isActive }) => ({ color: isActive ? theme.navHover : theme.navText })}
              >
                {n.label}
              </NavLink>
            ))}
            <button
              onClick={() => { cycleTheme(); }}
              className="mt-2 inline-flex w-fit items-center gap-2 px-4 py-2 rounded-full border text-sm font-medium"
              style={{ borderColor: theme.brand, color: theme.navText }}
            >
              <Palette size={16} />
              <span>Switch to {theme.nextLabel}</span>
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
